// 数据
import request from '@/utils/request';
export function onlineDevices(data) {
  return request({
    url: '/data/online_device',
    method: 'get',
    params: data
  });
}